<template>
    <v-list class="escenario-seleccion">
        <v-list-group v-model="mostrarOpciones" no-action :append-icon="opciones.length > 1 ? '$expand' : ''"
                      @click="seMuestranLasOpciones()">
            <template v-slot:activator>
                <v-list-item-content :class="{'sin-seleccion': hayError}">
                    <v-list-item-title v-if="escenarioOpcion == null">
                        {{ descripcionProcesada }}
                    </v-list-item-title>
                    <v-list-item-title v-if="escenarioOpcion != null">
                        {{ escenario[propiedad][campoNombre] }}
                        <v-tooltip v-if="campoDescripcion" bottom class="pl-2">
                            <template v-slot:activator="{on}">
                                <v-icon v-on="on">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ escenario[propiedad][campoDescripcion] }}</span>
                        </v-tooltip>
                    </v-list-item-title>
                </v-list-item-content>
            </template>

            <div v-for="(opcion, i) in opciones" :key="i">
                <v-list-item v-if="opcion[campoId] != escenarioOpcion" @click="seleccionaOpcion(opcion)" link>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ opcion[campoNombre] }}
                            <v-tooltip v-if="campoDescripcion" bottom class="pl-2">
                                <template v-slot:activator="{on}">
                                    <v-icon v-on="on">mdi-information-outline</v-icon>
                                </template>
                                <span>{{ opcion[campoDescripcion] }}</span>
                            </v-tooltip>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </div>
        </v-list-group>
    </v-list>
</template>

<script>
    export default {
        name: "EscenarioSeleccionComponente",
        data: function () {
            return {
                mostrarOpciones: false,
            }
        },
        props: {
            opciones: {type: Array, required: true},
            escenario: {type: Object, required: true},
            propiedad: {type: String, required: true},
            campoId: {type: String, required: true},
            campoNombre: {type: String, required: true},
            campoDescripcion: {type: [String, null], defaul: null},
            descripcion: {type: String}
        },
        computed: {
            escenarioOpcion: function () {
                if (typeof this.escenario == "undefined") return null;
                if (typeof this.escenario[this.propiedad] == "undefined" || this.escenario[this.propiedad] == null)
                    return null;

                return this.escenario[this.propiedad][this.campoId];
            },
            descripcionProcesada: function () {
                if (typeof this.descripcion == "undefined")
                    return `Selecciona ${this.propiedad}`;

                return this.descripcion;
            },
            hayError: function () {
                return typeof this.escenario[this.propiedad] == "undefined" || this.escenario[this.propiedad] == null;
            }
        },
        watch: {
            escenario: {
                handler() {
                    this.seleccionaSiSoloHayUnaOpcion();
                },
                deep: true
            },
            opciones: {
                handler() {
                    this.seleccionaSiSoloHayUnaOpcion();
                }
            }
        },
        methods: {
            seleccionaSiSoloHayUnaOpcion() {
                let esNullOUndefined = typeof this.escenario[this.propiedad] == "undefined"
                    || this.escenario[this.propiedad] == null;

                if (esNullOUndefined && this.opciones.length === 1) {
                    this.seleccionaOpcion(this.opciones[0]);
                }
            },
            seleccionaOpcion(opcion) {
                this.mostrarOpciones = false;
                this.$emit("change", opcion);
            },
            seMuestranLasOpciones() {
                this.mostrarOpciones = true;
            },
        }
    }
</script>

<style lang="scss">
    .escenario-seleccion {
        .v-list-group {
            background: #f7d9cd;
        }

        .v-list-item {
            min-height: 32px !important;
        }

        .v-list-item__content.sin-seleccion {
            color: #F44336 !important;
        }

        .v-list-item__content.sin-seleccion::before {
            .v-icon {
                color: #F44336 !important;
            }
        }

        .v-list-item__content {
            color: #40108e !important;

            .v-icon {
                color: #40108e !important;
            }
        }
    }
</style>